var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileBadgeQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "badge-bg",
    fill: "currentColor",
    stroke: "none",
    d: " M 18.2 8.4 Q 17.75 5.9 15.9 4.15 14.15 2.3 11.65 1.85 9.1 1.35 6.85 2.35 4.45 3.25 3.1 5.4 1.7 7.5 1.7 10 1.7 11.75 2.35 13.2 2.95 14.8 4.15 15.9 5.3 17.1 6.85 17.7 8.3 18.35 10 18.35 12.55 18.35 14.65 16.95 16.8 15.6 17.7 13.2 18.7 10.95 18.2 8.4 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    d: " M 9.85 13.35 L 9.45 13.6 Q 9.3 13.7 9.2 14.05 L 9.25 14.5 Q 9.3 14.65 9.55 14.9 9.7 15 10.05 15 10.4 15 10.6 14.8 10.85 14.45 10.85 14.2 10.85 13.9 10.7 13.75 10.65 13.6 10.35 13.4 L 9.85 13.35 M 11.75 5.6 Q 11.15 5.1 10.25 5 9.4 5 8.7 5.35 7.95 5.7 7.55 6.4 7.1 7.1 7.1 7.95 7.1 8.2 7.35 8.55 7.55 8.75 7.95 8.75 8.3 8.75 8.55 8.55 8.8 8.2 8.8 7.95 8.8 7.5 9 7.25 9.15 6.95 9.55 6.8 9.95 6.65 10.25 6.7 10.65 6.8 10.9 7.05 11.2 7.35 11.25 7.7 11.3 8 11.2 8.4 11.05 8.7 10.7 9 10.3 9.2 10.05 9.2 9.7 9.2 9.45 9.45 9.2 9.7 9.2 10 L 9.2 11.7 Q 9.2 11.95 9.45 12.3 9.65 12.5 10.05 12.5 10.4 12.5 10.6 12.3 10.85 11.95 10.85 11.7 L 10.85 10.7 Q 11.65 10.5 12.2 9.85 12.75 9.25 12.9 8.45 13.05 7.6 12.75 6.85 12.45 6.05 11.75 5.6 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileBadgeQuestion);
export default __webpack_public_path__ + "static/media/icon-profile-badge-question.0e935aa16a94a6d95ef872632deb2b49.svg";
export { ForwardRef as ReactComponent };